var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 0h-400v300h400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v180h400z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v180h400z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6172-22.387-50-50-50h-300c-27.6133 0-50 22.3828-50 50v380c0 27.617 22.3867 50 50 50h240l110-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6133 0-50-22.383-50-50v-380c0-27.6172 22.3867-50 50-50h300c27.613 0 50 22.3828 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0625-17.945-40-40-40h-300c-22.0547 0-40 17.9375-40 40v380c0 22.059 17.9453 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#549669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6133 0-50-22.383-50-50v-380c0-27.6172 22.3867-50 50-50h300c27.613 0 50 22.3828 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0625-17.945-40-40-40h-300c-22.0547 0-40 17.9375-40 40v380c0 22.059 17.9453 40 40 40z",
    fill: "#4c865f"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.355 384.973 96.79-96.789v96.789z",
    fill: "#4c865f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.613 0-50 22.383-50 50v60h110z",
    fill: "#91b79e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m95.7148 417.695h12.4332v-22.226h20.438v22.226h12.434v-57.695h-12.434v22.941h-20.438v-22.941h-12.4332z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.02 417.695h38.8v-12.254h-13.226v-45.441h-12.438v45.441h-13.136z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.227 417.695h14.777l10.812-34.582 10.809 34.582h14.254l7.434-57.695h-11.848l-5.094 40.605-12.699-40.605h-5.645l-13.031 40.957-4.808-40.957h-12.047z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e0e0e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m126.363 145.145-21.218 21.222 63.644 63.633 21.211-21.211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.145 166.367 21.21 21.211 63.641-63.633-21.211-21.218z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.637 187.578 21.218-21.223-63.644-63.628-21.211 21.211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.855 166.355-21.21-21.21-63.641 63.632 21.211 21.223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.004 90h-19.992l49.992 150h19.996z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtm);
export default __webpack_public_path__ + "static/media/htm.fa514ab0b0b2361d597b3157ed933d38.svg";
export { ForwardRef as ReactComponent };